<template>
    <div class="toggle-container">
      <button
        type="button"
        class="toggle"
        :class="{ 'toggle--active': ligado, 'toggle--disabled': disabled }"
        @click="switchToggle"
      >
        <div class="toggle__track"></div>
        <div class="toggle__thumb">
          <svg v-if="ligado" class="toggle__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 12L10 17L19 8" stroke="#003366" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </button>
      <input v-if="name" type="hidden" :name="name" :value="ligado ? '1' : '0'" :disabled="disabled">
    </div>
  </template>
  <script>
  export default {
    props: {
      modelValue: {
        type: Boolean,
        default: false
      },
      name: {
        type: String,
        required: false,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
    },
    emits: ['update:modelValue'],
    data() {
      return {
        estadoInterno: this.modelValue
      }
    },
    computed: {
      ligado() {
        return this.name ? this.estadoInterno : this.modelValue
      }
    },
    watch: {
      modelValue(valor) {
        this.estadoInterno = valor
      }
    },
    methods: {
      switchToggle() {
        if(this.disabled) return;

        const novoEstado = !this.ligado

        this.estadoInterno = novoEstado
        this.$emit('update:modelValue', novoEstado)
      }
    }
  }
  </script>
